import { useCardImage } from "../hooks/useCardImage";

const CARDBACK = "https://assets.tcgdex.net/univ/cardback.webp";

/**
 * <img> d'une carte, locale-d'abord (cf. hooks/useCardImage) : lit le cache
 * hors ligne si déjà synchronisé, sinon l'URL réseau habituelle — même
 * rendu qu'avant, juste centralisé pour ne plus répéter
 * `card.image_full ? card.image : ...` dans chaque composant qui affiche
 * une carte. L'appelant garde la responsabilité du placeholder "pas
 * d'image" (`card.image` falsy) : ce composant suppose `card.image` truthy.
 */
export const CardImage = ({ card, quality = "low", className, alt, loading = "lazy", style, onErrorSrc }) => {
  const src = useCardImage(card, quality);
  // Pas d'image du tout (carte jamais résolue) : cardback direct plutôt
  // qu'un <img> cassé. N'arrive en pratique que si l'appelant n'a pas déjà
  // filtré sur `card.image` (les grilles le font ; CardDetailModal non).
  if (!src) return <img src={CARDBACK} alt={alt ?? card.name} className={className} style={style} loading={loading} />;
  return (
    <img
      src={src}
      alt={alt ?? card.name}
      className={className}
      loading={loading}
      style={style}
      onError={(e) => {
        const img = e.currentTarget;
        // TCGdex a parfois la grande image sans la vignette (constaté sur
        // sv02-108 Tauros de Paldea, 2026-09-20 : /low.webp en 404, /high.webp
        // en 200). Avant d'abandonner, retenter une fois en haute qualité.
        if (img.src.endsWith("/low.webp") && !img.dataset.highRetried) {
          img.dataset.highRetried = "1";
          img.src = img.src.slice(0, -"/low.webp".length) + "/high.webp";
          return;
        }
        img.src = typeof onErrorSrc === "function" ? onErrorSrc() : (onErrorSrc || CARDBACK);
      }}
    />
  );
};
